module.exports = __webpack_public_path__ + "static/media/아.74a785bb.jpg";